document.addEventListener('DOMContentLoaded', function () {
    const table = document.querySelector('.multiple-readings-table');
    if (!table) {
        return;
    }

    const selectAll = document.getElementById('multiple-readings-select-all');
    const rowSelections = Array.from(table.querySelectorAll('.multiple-readings-row-select'));

    /**
     * @param {HTMLInputElement} selection - the checkbox of one row
     */
    function updateRow(selection) {
        const row = selection.closest('.multiple-readings-row');

        if (!row) {
            return;
        }

        row.classList.toggle('is-not-selected', !selection.checked);

        // a row that is not being submitted should not invite typing either
        row.querySelectorAll('.reading-value, .reading-date').forEach(function (input) {
            input.disabled = !selection.checked;
        });
    }

    /** Put the header checkbox in the state the rows below it add up to. */
    function syncSelectAll() {
        // the box in the header only exists while there is something to fill in
        if (!selectAll) {
            return;
        }

        selectAll.checked = rowSelections.every(function (item) {
            return item.checked;
        });
        selectAll.indeterminate = !selectAll.checked && rowSelections.some(function (item) {
            return item.checked;
        });
    }

    rowSelections.forEach(function (selection) {
        updateRow(selection);
        selection.addEventListener('change', function () {
            updateRow(selection);
            syncSelectAll();
        });
    });

    // rows can arrive switched off, from a submit that kept them that way
    syncSelectAll();

    if (selectAll) {
        selectAll.addEventListener('change', function () {
            rowSelections.forEach(function (selection) {
                selection.checked = selectAll.checked;
                updateRow(selection);
            });
            selectAll.indeterminate = false;
        });
    }

    // The table shows the open requests. Switching that off adds the history, and
    // the processed part of it is not on the page until it is asked for: it costs a
    // KAS call per address, so fetching it needs a reload. Once it is there, the
    // switch only shows and hides.
    const openOnly = document.getElementById('open-requests-only');

    if (openOnly) {
        const loadUrl = openOnly.dataset.loadUrl;

        const submitButton = document.querySelector('.multiple-readings-actions button[type="submit"]');

        const wrap = table.closest('.multiple-readings-table-wrap');

        /** Show either the open requests or the history, never both. */
        const applyOpenOnly = function () {
            table.classList.toggle('is-open-only', openOnly.checked);
            table.classList.toggle('is-closed-only', !openOnly.checked);

            // the frame follows, so an empty table leaves no empty box behind
            if (wrap) {
                wrap.classList.toggle('is-open-only', openOnly.checked);
            }

            // There is nothing to hand in while the history is on screen. Disabled
            // rather than hidden: a button that disappears leaves you wondering
            // where it went, one that is greyed out shows it is coming back.
            if (submitButton) {
                submitButton.disabled = !openOnly.checked;
            }
        };

        openOnly.addEventListener('change', function () {
            if (loadUrl && !openOnly.checked) {
                // it is on its way; switching again while the page reloads would
                // only produce a second request
                openOnly.disabled = true;
                window.location = loadUrl;

                return;
            }

            applyOpenOnly();
        });

        applyOpenOnly();
    }

    // Filtering what is on screen. It says nothing about which rows are handed in:
    // a row that is filtered away keeps its checkbox and is still submitted, the
    // same way a row scrolled out of view is.
    const addressFilter = document.getElementById('multiple-readings-filter-address');
    const typeFilter = document.getElementById('multiple-readings-filter-type');

    if (addressFilter || typeFilter) {
        /** Hide every row the address search and the type filter do not both allow. */
        const filterRows = function () {
            const words = (addressFilter ? addressFilter.value.trim().toLowerCase().split(/\s+/).filter(Boolean) : []);
            const type = (typeFilter ? typeFilter.value : '');

            table.querySelectorAll('.multiple-readings-row').forEach(function (row) {
                const search = (row.dataset.search || '');
                // every word has to occur, so "rijen 5121" narrows down instead of
                // widening out the way a single string would
                const matches = words.every(function (word) {
                    return search.indexOf(word) !== -1;
                }) && (!type || (row.dataset.type === type));

                row.classList.toggle('is-filtered-out', !matches);

                const detail = table.querySelector('[data-flow-detail="' + row.dataset.flowId + '"]');
                if (detail) {
                    detail.classList.toggle('is-filtered-out', !matches);
                }
            });
        };

        if (addressFilter) {
            addressFilter.addEventListener('input', filterRows);

            // the field is only there while it is being used; closing it clears the
            // search as well, or the table would stay filtered by something invisible
            const searchToggle = document.getElementById('multiple-readings-search-toggle');

            if (searchToggle) {
                // The field disappears, the search does not: the magnifier changes
                // colour so the rows that are missing from the table are accounted
                // for, and opening it again shows the term that did it.
                /** Colour the magnifier while a search term is hiding rows. */
                const markToggle = function () {
                    searchToggle.classList.toggle('is-active', addressFilter.value.trim() !== '');
                };

                /** @param {boolean} clear - also empty the term, so every row comes back */
                const closeSearch = function (clear) {
                    addressFilter.hidden = true;

                    if (clear) {
                        addressFilter.value = '';
                        filterRows();
                    }

                    markToggle();
                };

                addressFilter.addEventListener('input', markToggle);

                searchToggle.addEventListener('click', function () {
                    if (addressFilter.hidden) {
                        addressFilter.hidden = false;
                        addressFilter.focus();
                        addressFilter.select();

                        return;
                    }

                    closeSearch(false);
                });

                // escape is the way back to the whole table, so that one does clear
                addressFilter.addEventListener('keydown', function (event) {
                    if (event.key === 'Escape') {
                        closeSearch(true);
                    }
                });

                document.addEventListener('click', function (event) {
                    if (addressFilter.hidden
                        || (event.target === addressFilter)
                        || searchToggle.contains(event.target)
                    ) {
                        return;
                    }

                    closeSearch(false);
                });
            }
        }

        if (typeFilter) {
            typeFilter.addEventListener('change', filterRows);
        }
    }

    const readingInputs = Array.from(table.querySelectorAll('.reading-value'));
    readingInputs.forEach(function (input, index) {
        input.addEventListener('keydown', function (event) {
            if (event.key !== 'Enter') {
                return;
            }

            event.preventDefault();
            const nextInput = readingInputs[index + 1];
            if (nextInput) {
                nextInput.focus();
                nextInput.select();
            }
        });
    });

    const firstDetail = table.querySelector('.multiple-readings-detail');
    if (firstDetail) {
        firstDetail.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
});
